// Action type constants for reducers
export const GET_USER = 'GET_USER';
export const CREATE_STORE = 'CREATE_STORE';
export const GET_STORE = 'GET_STORE';
export const USER_LOADING = 'USER_LOADING';
export const USER_ERROR = 'USER_ERROR';
export const USER_SUCCESS = 'USER_SUCCESS';
export const UPDATE_THUMBNAIL_IMAGE = 'UPDATE_THUMBNAIL_IMAGE';
export const SEARCH_USERS = 'SEARCH_USERS';
export const LIKE_USER = 'LIKE_USER';
export const UNLIKE_USER = 'UNLIKE_USER';
export const GET_USER_LIKES = 'GET_USER_LIKES';
//Team
export const USER_CREATE_TEAM = 'USER_CREATE_TEAM';
export const USER_INVITE = 'USER_INVITE';
export const USER_INVITATIOINS = 'USER_INVITATIOINS';
export const INVITATION_LOADING = 'INVITATION_LOADING';
export const INVITATION_SUCCESS = 'INVITATION_SUCCESS';
export const INVITATION_ERROR = 'INVITATION_ERROR';
export const USER_ACCEPT_INVITATION = 'USER_ACCEPT_INVITATION';
// User Profile Update
export const USER_PROFILE_UPDATE = 'USER_PROFILE_UPDATE';
export const USER_PROFILE_UPDATE_LOADING = 'USER_PROFILE_UPDATE_LOADING';
export const USER_PROFILE_UPDATE_ERROR = 'USER_PROFILE_UPDATE_ERROR';
export const USER_PROFILE_UPDATE_SUCCESS = 'USER_PROFILE_UPDATE_SUCCESS';
